<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1320px"
    top="2vh"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
  >
    <div style="width: 100%" class="scrollable-div">
      <div style="width: 100%;padding-top: 5px">
        <div class="section">
          <el-form
            label-position="right"
            label-width="60px"
            style="width: 100%;"
          >
            <div style="display: flex">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.MasterBillNo') }}</span>
                <div style="display:flex;">
                  <el-input v-model="mblData.mbl" no="mbl" :disabled="true" style="width: 120px" />
                  <span class="el-button el-button--primary el-button--mini" style="min-width:30px!important;margin-left:2px" @click="selectMBLNoHandler">...</span>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PurchaseMethod') }}</span>
                <cargo-advance-select
                  ref="purchaseMethod"
                  tag-value="code"
                  :static-options="SystemConstants.PURCHASE_METHODS"
                  :default-value="mblData.purchaseMethod"
                  style="width: 150px"
                  :disabled="Boolean(mblData.mbl)"
                  @parentCallBack="p=>{mblData.purchaseMethod=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PurchaseSource') }}</span>
                <cargo-advance-select
                  no="purchaseSource"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :method-params="{active:true}"
                  :default-value="mblData.purchaseSource||''"
                  :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                  :fields="['shortName', 'chineseName']"
                  placeholder=" "
                  style="width: 150px"
                  :disabled="Boolean(mblData.mbl)"
                  @parentCallBack="p => {mblData.purchaseSource=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ServiceProduct') }}</span>
                <cargo-advance-select
                  ref="serviceProduct"
                  :select-type="TYPE_NAMES.basic_data_AirServiceProduct"
                  callback-method-type="value"
                  :default-value="mblData.serviceProduct"
                  :callback-params="{key:'serviceProduct'}"
                  style="width: 150px"
                  @parentCallBack="p=>{mblData.serviceProduct=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AirlineProductCode')">
                <cargo-advance-select
                  no="airlineProductUuid"
                  :clearable="false"
                  filterable
                  :static-options="airlineProductDownList"
                  tag-value="uuid"
                  tag-name="name"
                  :filter-tag-names="['name']"
                  :static-component="new AutoComplete()"
                  callback-method-type="value"
                  :default-value="mblData.airlineProductUuid"
                  :callback-params="{key:'airlineProductUuid'}"
                  style="width: 150px"
                  @parentCallBack="p=>{mblData.airlineProductUuid=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_RouteMarking')">
                <el-input v-model="mblData.routeMarking" no="routeMarking" style="width: 150px" />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_FlightNumber') }}</span>
                <el-input v-model="mblData.voyageFlight" no="voyageFlight" style="width: 120px" />
              </el-form-item>
              <el-form-item label-width="40px">
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Airline2') }}</span>
                <cargo-advance-select
                  no="41"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{airCmp:true, companyLob:'airExport',active:true}"
                  :default-value="mblData.carrierId||''"
                  :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                  :fields="['shortName', 'chineseName']"
                  placeholder=" "
                  style="width: 150px"
                  @parentCallBack="p => {this.mblData.carrierId = p.value||0}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_FlightDate') }}</span>
                <el-date-picker
                  ref="etd"
                  v-model="mblData.etd"
                  no="44"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  clearable
                  style="width:150px;"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_OriginPort') }}</span>
                <cargo-advance-select
                  ref="portOfDeparture"
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="mblData.portOfDeparture"
                  style="width:110px;"
                  tag-name="englishName"
                  placeholder=" "
                  @parentCallBack="p=>{mblData.portOfDeparture = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TransitPort') + '1'">
                <cargo-advance-select
                  ref="transitPort1"
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="mblData.transitPort1"
                  style="width:110px;"
                  tag-name="englishName"
                  placeholder=" "
                  @parentCallBack="p=>{mblData.transitPort1 = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TransitPort') + '2'">
                <cargo-advance-select
                  ref="transitPort2"
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="mblData.transitPort2"
                  style="width:110px;"
                  tag-name="englishName"
                  placeholder=" "
                  @parentCallBack="p=>{mblData.transitPort2 = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfDestination')">
                <span slot="label" class="blue">{{ $t('SeaExport.PortOfDestination') }}</span>
                <cargo-advance-select
                  ref="destinationPortCode"
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="mblData.destinationPortCode"
                  style="width:110px;"
                  tag-name="englishName"
                  placeholder=" "
                  @parentCallBack="p=>{mblData.destinationPortCode = p.value}"
                />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item :label="$t('CargoMsg.Cargo_SecondLegFlight')">
                <el-input v-model="mblData.secondFlight" no="secondFlight" style="width: 150px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondLegAirline')">
                <cargo-advance-select
                  no="secondCarrierId"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{airCmp:true, companyLob:'airExport',active:true}"
                  :default-value="mblData.secondCarrierId||''"
                  :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                  :fields="['shortName', 'chineseName']"
                  placeholder=" "
                  style="width: 150px"
                  @parentCallBack="p => {this.mblData.secondCarrierId = p.value||0}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondLegDocumentNumber')">
                <el-input v-model="mblData.secondMbl" no="secondMbl" style="width: 150px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondLegETD')">
                <el-date-picker
                  v-model="mblData.secondEtd"
                  no="secondEtd"
                  type="datetime"
                  style="width: 150px"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondLegETA')">
                <el-date-picker
                  v-model="mblData.secondEta"
                  no="secondEta"
                  type="datetime"
                  style="width: 150px"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
                <cargo-department-select
                  no="77"
                  :enables="true"
                  :office-id="Number($store.getters.currentOfficeId)"
                  :department-id="Number(mblData.opDepartment)"
                  placeholder=" "
                  @change="p=>{mblData.opDepartment=p.value}"
                />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item :label="$t('CargoMsg.Cargo_ThirdLegFlight')">
                <el-input v-model="mblData.thirdFlight" no="thirdFlight" style="width: 150px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ThirdLegAirline')">
                <cargo-advance-select
                  no="thirdCarrierId"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{airCmp:true, companyLob:'airExport',active:true}"
                  :default-value="mblData.thirdCarrierId||''"
                  :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                  :fields="['shortName', 'chineseName']"
                  placeholder=" "
                  style="width: 150px"
                  @parentCallBack="p => {this.mblData.thirdCarrierId = p.value||0}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ThirdLegDocumentNumber')">
                <el-input v-model="mblData.thirdMbl" no="thirdMbl" style="width: 150px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ThirdLegETD')">
                <el-date-picker
                  v-model="mblData.thirdEtd"
                  no="thirdEtd"
                  type="datetime"
                  style="width: 150px"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ThirdLegETA')">
                <el-date-picker
                  v-model="mblData.thirdEta"
                  no="thirdEta"
                  type="datetime"
                  style="width: 150px"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div style="flex-direction: column">
        <div class="section">
          <el-form
            label-position="right"
            label-width="62px"
            style="width: 100%;"
          >
            <div class="goods-info">
              <el-form-item class="auto-width">
                <div style="display: flex;text-align: left" class="title-row">
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:180px;text-align: center;">{{ $t('SeaExport.Quantity') }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:180px;text-align: center;">{{ $t('SeaExport.Weight') }}KGS</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:180px;text-align: center;">{{ $t('SeaExport.Cubage') }}CBM</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:180px;text-align: center;">{{ $t('SeaExport.ChargedWeight') + 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:180px;text-align: center;">{{ $t('queryJob.Density') }}kg/m³</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:230px;text-align: center;">{{ $t('CargoMsg.Cargo_Size') }}CM</div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Booking')">
                <auto-number-input
                  v-model="mblData.quantityBooking"
                  no="94"
                  :precision="0"
                  :min="0"
                  style="width: 180px"
                />
                <auto-number-input
                  v-model="mblData.weightBooking"
                  no="95"
                  :precision="3"
                  :min="0"
                  style="width: 180px"
                  @change="weightCubAgeChangeHandler"
                />
                <auto-number-input
                  v-model="mblData.cubageBooking"
                  no="96"
                  :precision="3"
                  :min="0"
                  style="width: 180px"
                  @change="weightCubAgeChangeHandler"
                />
                <auto-number-input
                  v-model="mblData.chargeWeightBooking"
                  no="97"
                  :precision="3"
                  :min="0"
                  style="width: 180px"
                />
                <auto-number-input
                  v-model="mblData.densityBooking"
                  :precision="3"
                  :min="0"
                  no="141"
                  style="width: 180px"
                />
                <el-input v-model="measurements" no="9" :disabled="true" style="width: 230px;padding-right: 5px" />
                <el-button type="primary" @click="onView(measurements)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Frontcabin')" class="goods-info-item">
                <auto-number-input
                  v-model="mblData.quantityActual"
                  no="98"
                  :precision="0"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                />
                <auto-number-input
                  v-model="mblData.weightActual"
                  no="99"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  @change="weightActualChange"
                />
                <auto-number-input
                  v-model="mblData.cubageActual"
                  no="100"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  @change="weightActualChange"
                />
                <auto-number-input
                  v-model="mblData.cWeight"
                  no="101"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  @change="pm.weightCubageChangeHandler('chargeWeightActual')"
                />
                <auto-number-input
                  v-model="mblData.densityActual"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  no="142"
                />
                <el-input v-model="mblData.dimensionsActual" no="9" :disabled="true" style="width: 230px;padding-right: 5px" />
                <el-button type="primary" @click="onView(mblData.dimensionsActual)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.FreightStation')" class="goods-info-item">
                <auto-number-input
                  v-model="mblData.quantityStation"
                  no="150"
                  :precision="0"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                />
                <auto-number-input
                  v-model="mblData.weightStation"
                  no="151"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  @change="weightStationChange"
                />
                <auto-number-input
                  v-model="mblData.cubageStation"
                  no="152"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                  @change="weightStationChange"
                />
                <auto-number-input
                  v-model="mblData.chargeWeightStation"
                  no="153"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  style="width: 180px"
                />
                <auto-number-input
                  v-model="mblData.densityStation"
                  :precision="3"
                  :min="0"
                  no="154"
                  :disabled="true"
                  style="width: 180px"
                />
                <el-input v-model="mblData.dimensionsStation" :disabled="true" no="9" style="width: 230px;padding-right: 5px" />
                <el-button type="primary" @click="onView(mblData.dimensionsStation)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div style="width: 100%;padding-top: 5px">
        <div class="section">
          <el-form
            label-position="right"
            label-width="62px"
            style="width: 100%;"
          >
            <div style="display: flex">
              <el-form-item :label="$t('CargoMsg.Cargo_FreightUnitPrice')">
                <div style="display: flex">
                  <auto-number-input
                    v-model="mblData.freightAmount"
                    no="freightAmount"
                    :precision="2"
                    :enforce-min="true"
                    style="width: 200px"
                    :min="0"
                  />
                  <el-select v-model="mblData.freightType" no="freightType" style="width: 80px">
                    <el-option :label="$t('CargoMsg.Cargo_UnitPrice')" :value="0" />
                    <el-option :label="$t('CargoMsg.Cargo_TotalPrice')" :value="1" />
                  </el-select>
                  <cargo-advance-select
                    filterable
                    style="width: 80px"
                    :clearable="false"
                    :select-type="selectTypeNames.basic_data_Currency"
                    :default-value="mblData.freightCurrency"
                    @parentCallBack="item=>mblData.freightCurrency=item.value"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SignatureWeight')">
                <auto-number-input
                  v-model="mblData.signatureWeight"
                  no="90"
                  style="width: 150px"
                  :precision="2"
                  :enforce-min="true"
                  :min="0"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SignatureDimensions')">
                <auto-number-input
                  v-model="mblData.signatureDimensions"
                  no="signatureDimensions"
                  style="width: 550px"
                  :precision="0"
                  :min="0"
                />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item :label="$t('CargoMsg.Cargo_SignatureRemarks')">
                <el-input v-model="mblData.signatureRemark" no="signatureRemark" style="width: 572px;" type="textarea" :rows="5" maxlength="200" show-word-limit />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_FoldedWeightRemarks')">
                <el-input v-model="mblData.foldedWeightRemark" no="foldedWeightRemark" style="width: 550px;" type="textarea" :rows="5" maxlength="200" show-word-limit />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <div style="display: flex;align-items: center;width: 100%">
        <div style="padding-left:10px;width: 10%;">
          <span>{{ $t('CargoMsg.Cargo_OrderQuantity') }}: {{ lclData.length }}</span>
        </div>
        <div style="width: 90%;text-align: center">
          <div style="padding-right: 10%">
            <el-button type="primary" @click="routeBookingStagingHandler">{{ $t('queryJob.temporaryStorage') }}</el-button>
            <el-button type="primary" @click="okHandler(false)">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
            <el-button type="primary" @click="okAndBookingHandler">{{ $t('CargoMsg.Cargo_ConfirmAndBookingCompleted') }}</el-button>
          </div>
        </div>
      </div>

      <hr>
      <div v-for="(item,index) in lclData" :key="index" class="container">
        <div class="order-info">
          <h2 style="font-size: 20px">{{ String(index+1).padStart(2, '0') }}</h2>
          <h2>{{ $t('CargoMsg.Cargo_OrderNumber') }}：</h2>
          <a href="javascript:void(0)" style="color: #0A0AFF;" @click="jumpBusinessHandler(item.jobNo)">{{ item.jobNo }}</a>
          <p>{{ $t('CargoMsg.Cargo_SeparateNumber') }}：</p>
          {{ item.hbl }}
        </div>
        <el-form
          label-position="right"
          label-width="62px"
          style="width: 100%;padding-left: 20px"
        >
          <div class="goods-info">
            <div class="section">
              <div style="display: flex">
                <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
                  <cargo-company-select
                    :method-params="{customer:true}"
                    :default-value="item.customerId"
                    no="customerId"
                    style="width: 500px"
                    :disabled="true"
                    @change="p=>{item.customerId=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.SpaceRquirement')">
                  <el-input v-model="item.cabinReq" no="9" style="width: 300px;" :disabled="true" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.OnBoardRequirements')">
                  <el-input v-model="item.loadReq" no="9" style="width: 360px;" :disabled="true" />
                </el-form-item>
              </div>
              <div style="display: flex">
                <el-form-item :label="$t('CargoMsg.Cargo_TransshipmentPort')">
                  <cargo-advance-select
                    ref="transshipmentPort"
                    no="transshipmentPort"
                    filterable
                    :select-type="TYPE_NAMES.basic_data_Airport"
                    :default-value="item.transshipmentPort"
                    tag-name="englishName"
                    style="width: 163px"
                    placeholder=" "
                    @parentCallBack="p=>{item.transshipmentPort = p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_TransshipmentFee')">
                  <div style="display: flex">
                    <auto-number-input
                      v-model="item.transshipAmount"
                      no="90"
                      style="width: 100px"
                      :precision="2"
                      :enforce-min="true"
                      :min="0"
                    />
                    <el-select v-model="item.transshipType" style="width: 100px">
                      <el-option :label="$t('CargoMsg.Cargo_UnitPrice')" :value="0" />
                      <el-option :label="$t('CargoMsg.Cargo_TotalPrice')" :value="1" />
                    </el-select>
                    <cargo-advance-select
                      filterable
                      style="width: 100px"
                      :clearable="false"
                      :select-type="selectTypeNames.basic_data_Currency"
                      :default-value="item.transshipCurrency"
                      @parentCallBack="i=>item.transshipCurrency=i.value"
                    />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_market')">
                  <cargo-user-select
                    ref="sales"
                    no="72"
                    :disabled="true"
                    :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales',active:true}"
                    :default-value="item.sales||''"
                    :static-options="salesList"
                    style="width: 80px;flex: 1"
                    @change="p=>{item.sales = p.value}"
                  />&nbsp;
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ResponsibleCustomerService')">
                  <cargo-user-select
                    ref="csr"
                    no="70"
                    :disabled="true"
                    :method-params="{category:'role',shape:'csr'}"
                    :default-value="item.csr||''"
                    :merge-load="true"
                    style="width: 80px;"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ResponsibleOperator')">
                  <cargo-user-select
                    ref="csr"
                    no="70"
                    :disabled="true"
                    :method-params="{category:'role',shape:'op'}"
                    :default-value="item.op||''"
                    :merge-load="true"
                    style="width: 75px;"
                  />
                </el-form-item>
              </div>
              <el-form-item class="auto-width">
                <div style="display: flex;text-align: left" class="title-row">
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:135px;text-align: center;">{{ $t('SeaExport.Quantity') }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:135px;text-align: center;">{{ $t('SeaExport.Weight') }}KGS</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:135px;text-align: center;">{{ $t('SeaExport.Cubage') }}CBM</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:135px;text-align: center;">{{ $t('SeaExport.ChargedWeight') + 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:135px;text-align: center;">{{ $t('queryJob.Density') }}kg/m³</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:240px;text-align: center;">{{ $t('CargoMsg.Cargo_Size') }}CM</div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Booking')">
                <auto-number-input
                  v-model="item.quantityBooking"
                  no="94"
                  :precision="0"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.weightBooking"
                  no="95"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.cubageBooking"
                  no="96"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.chargeWeightBooking"
                  no="97"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.densityBooking"
                  :precision="3"
                  :min="0"
                  no="141"
                  style="width: 135px"
                  :disabled="true"
                />
                <el-input v-model="item.bookingDimensions" no="9" style="width: 240px;padding-right: 5px" :disabled="true" />
                <el-button type="primary" :disabled="false" @click="onView(item.bookingDimensions)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Frontcabin')" class="goods-info-item">
                <auto-number-input
                  v-model="item.quantityActual"
                  no="98"
                  :precision="0"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.weightActual"
                  no="99"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.cubageActual"
                  no="100"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.cWeight"
                  no="101"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.densityActual"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  no="142"
                  :disabled="true"
                />
                <el-input v-model="item.dimensionsActual" no="9" style="width: 240px;padding-right: 5px" :disabled="true" />
                <el-button type="primary" @click="onView(item.dimensionsActual)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.FreightStation')" class="goods-info-item">
                <auto-number-input
                  v-model="item.quantityStation"
                  no="150"
                  :precision="0"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.weightStation"
                  no="151"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.cubageStation"
                  no="152"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.chargeWeightStation"
                  no="chargeWeightStation"
                  :precision="3"
                  :min="0"
                  style="width: 135px"
                  :disabled="true"
                />
                <auto-number-input
                  v-model="item.densityStation"
                  :precision="3"
                  :min="0"
                  no="densityStation"
                  style="width: 135px"
                  :disabled="true"
                />
                <el-input v-model="item.dimensionsStation" no="9" style="width: 240px;padding-right: 5px" :disabled="true" />
                <el-button type="primary" @click="onView(item.dimensionsStation)">{{ $t('SeaExport.View') }}</el-button>
              </el-form-item>
            </div>

            <div style="display: flex">
              <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
                <cargo-rich-textarea
                  v-model="item.cargoEnglishName"
                  no="110"
                  :text-chars="0"
                  :warning-count="45"
                  :english-letter-auto-uppercase="true"
                  style="height: 110px;width: 345px"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Marks')" class="auto-width">
                <cargo-rich-textarea
                  v-model="item.mark"
                  no="111"
                  :text-chars="0"
                  :warning-count="45"
                  :auto-uppercase="true"
                  style="height: 110px;width: 345px"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="default" @click="onCancel(false)">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>
    <!--选择主单-->
    <select-mawb-dialog :visible.sync="selectMawbDialog.visible" :carrier-id="selectMawbDialog.carrierId" :type="selectMawbDialog.type" :operate-type="selectMawbDialog.operateType" @enterEvent="selectedMAWBHandler" />

    <!-- 查看尺寸 -->
    <el-dialog
      v-if="viewWindow.visible"
      v-el-drag-dialog
      :visible.sync="viewWindow.visible"
      :title="$t('SeaExport.View')"
      width="300px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="section" style="flex: 1">
        <el-form :inline="true" label-width="80px" label-position="left">
          <el-form-item label-width="0">
            <cargo-rich-textarea
              v-model="viewWindow.viewValue"
              no="viewValue"
              :text-chars="0"
              :warning-count="1000"
              style="height: 110px;width: 280px"
              :disabled="true"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button @click="viewWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { TabGeneralHP } from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralHP'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { User } from '@/class/model/sys/User'
import { handleBlur } from '@/utils/commonUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import { MblTemporaryStorage } from '@/class/model/booking/MblTemporaryStorage'
import {
  callBackJobFunc, changeMAWBNo, routeBookingCheckMeasurementsFunc,
  routeBookingDetailFunc,
  routeBookingStagingFunc,
  updateRouteBookingFunc
} from '@/api/AirExport/airExportJob'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getUuid } from '@/utils'
import SelectMawbDialog from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/SelectMAWBDialog.vue'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'

export default {
  name: 'RouteDetail',
  components: { cargoDepartmentSelect, SelectMawbDialog, cargoUserSelect, cargoRichTextarea, cargoCompanySelect, AutoNumberInput, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    jobUuid: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    secondaryConfirmation: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      AutoComplete,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      cWeightIsCeil: false, // 计费重量是否取整
      splitBubbleCollectionFormat: false, // 分泡收取格式
      salesList: [],
      airlineProductDownList: [],
      config: {},
      pm: new TabGeneralHP(this),
      mblData: new MblTemporaryStorage().fillDefaultValue().getData(), // 暂存数据
      lclData: [],
      measurements: '',
      viewWindow: {
        visible: false,
        viewValue: ''
      },
      selectMawbDialog: {
        btnName: this.$t('SeaExport.PleaseSelect'),
        visible: false,
        type: '',
        carrierId: 0,
        operateType: -1
      }
    }
  },
  computed: {
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    SystemConstants() {
      return SystemConstants
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    handleBlur,
    async init() {
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
      this.cWeightIsCeil = Number(this.config.get('AEcWeightCeil')) // 计费重量是否取整
      this.splitBubbleCollectionFormat = Number(this.config.get('SplitBubbleCollectionFormat')) === 1
      if (this.salesOfficeCheck) {
        this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, this.$store.getters.currentOfficeId, true)
      } else {
        this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
      }
      // 初始化 航线产品下拉列表
      await queryAirlineProductDownList({ containVoyage: false, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.airlineProductDownList = res.data
      })
      this.handleInfo()
    },
    async handleInfo() {
      this.loading = getLoading4Cxt()
      const jobKeys = this.rows.map(item => item.uuid)
      await routeBookingDetailFunc({ keys: jobKeys, anyStr: this.jobUuid, anyBool: this.secondaryConfirmation }).then((res) => {
        this.lclData = []
        this.mblData = new MblTemporaryStorage().fillDefaultValue().getData()
        if (res.data) {
          for (const data of res.data) {
            if (data.masterFlag) {
              this.mblData = data
            } else {
              this.lclData.push(data)
            }
          }
          this.setCargoSize()
        }
      }).finally(res => {
        this.loading.close()
      })
    },
    onView(value) {
      this.viewWindow.viewValue = value
      this.viewWindow.visible = true
    },
    // 暂存
    async routeBookingStagingHandler(tip = true) {
      const check = this.checkStaging()
      if (!check) {
        return
      }
      this.loading = getLoading4Cxt()
      const data = this.mblData
      if (data && !data.jobUuid) {
        // 没有主票情况下 创建一个临时uuid
        data.jobUuid = 'addRouteDetail_' + getUuid()
      }
      data.lclData = this.lclData || []
      await routeBookingStagingFunc(data).then(async(res) => {
        if (res.data) {
          data.jobUuid = res.data
        }
        if (tip) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.onCancel(true)
          this.loading.close()
        }
      })
    },
    // 确认
    async okHandler(isBooking = false) {
      // 先保存数据
      try {
        const check = this.checkCallbackJob()
        if (!check) {
          return
        }
        // 校验长宽高 这个仅提示，不强制
        if (this.mblData.airlineProductUuid) {
          routeBookingCheckMeasurementsFunc({
            keys: this.lclData.map(row => row.jobUuid),
            anyStr: this.mblData.airlineProductUuid,
            anyDate: this.mblData.etd
          }).then(async(res) => {
            if (res.data) {
              this.$confirm(this.$t('CargoMsg.Cargo_DimensionsExceedRouteProductLimits'), this.$t('common.tips.confirm'), {
                confirmButtonText: this.$t('common.btn.yes'),
                cancelButtonText: this.$t('common.btn.no'),
                closeOnClickModal: false,
                type: 'info'
              }).then(async(res) => {
                await this.routeBookingStagingHandler(false)
                await this.callBackJobHandler(isBooking)
              }).catch(() => { })
            } else {
              await this.routeBookingStagingHandler(false)
              await this.callBackJobHandler(isBooking)
            }
          })
        } else {
          await this.routeBookingStagingHandler(false)
          await this.callBackJobHandler(isBooking)
        }
      } catch (e) {
        if (this.loading) {
          this.loading.close()
        }
        console.log('okHandler', e)
      }
    },
    checkStaging() {
      if (!this.mblData.etd) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_FlightDate'))
        return false
      }
      if (!this.mblData.portOfDeparture) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_OriginPort'))
        return false
      }
      if (!this.mblData.destinationPortCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.PortOfDestination'))
        return false
      }
      if (!this.mblData.opDepartment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.OperationDepartment'))
        return false
      }
      return true
    },
    checkCallbackJob() {
      if (!this.mblData.mbl) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.MasterBillNo'))
        return false
      }
      if (!this.mblData.purchaseMethod) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_PurchaseMethod'))
        return false
      }
      if (!this.mblData.purchaseSource) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_PurchaseSource'))
        return false
      }
      if (!this.mblData.serviceProduct) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_ServiceProduct'))
        return false
      }
      if (!this.mblData.voyageFlight) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_FlightNumber'))
        return false
      }
      if (!this.mblData.carrierId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_Airline2'))
        return false
      }
      if (!this.mblData.etd) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_FlightDate'))
        return false
      }
      if (!this.mblData.portOfDeparture) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_OriginPort'))
        return false
      }
      if (!this.mblData.destinationPortCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.PortOfDestination'))
        return false
      }
      if (!this.mblData.opDepartment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.OperationDepartment'))
        return false
      }
      return true
    },
    async callBackJobHandler(isBooking = false) {
      let keys = []
      const masterKey = this.mblData.jobUuid
      keys.push(this.mblData.jobUuid)
      if (this.lclData) {
        keys = [... this.lclData.map(item => item.jobUuid), ... keys]
      }
      this.loading = getLoading4Cxt()
      // 确认数据
      await callBackJobFunc({ keys: keys, anyStr: masterKey, anyBool: this.secondaryConfirmation }).then(res => {
        if (res.data === 'SaveSucceed') {
          if (isBooking) {
            // 订舱完成
            this.bookingCompletionHandler()
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_ConfirmedSuccessfully'))
            this.loading.close()
            this.onCancel(true)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_' + res.data))
          this.loading.close()
        }
      })
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    },
    async okAndBookingHandler() {
      // 确认
      await this.okHandler(true)
    },
    // 订舱完成
    async bookingCompletionHandler() {
      const keys = this.lclData.map(item => item.jobUuid)
      if (this.mblData.jobUuid) {
        keys.push(this.mblData.jobUuid)
      }
      const params = {
        keys: keys,
        type: 1,
        bookingCompletion: 1
      }
      this.loading = getLoading4Cxt()
      updateRouteBookingFunc(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_BookingCompletion'))
        this.onCancel(true)
      }).finally(() => {
        this.loading.close()
      })
    },
    selectMBLNoHandler() {
      this.selectMawbDialog.type = 'new'
      this.selectMawbDialog.carrierId = this.mblData.carrierId || 0
      this.selectMawbDialog.visible = true
    },
    selectedMAWBHandler(data = null) {
      this.selectMawbDialog.visible = false
      if (data) {
        // 有航空公司 就是航司
        if (data.carrierId) {
          this.mblData.purchaseMethod = SystemConstants.PURCHASE_METHOD_AIRLINE.code
          this.mblData.purchaseSource = data.carrierId || 0
        }
        // 有订舱代理 优先代理
        if (data.bookingAgentId) {
          this.mblData.purchaseMethod = SystemConstants.PURCHASE_METHOD_AGENT.code
          this.mblData.purchaseSource = data.bookingAgentId || 0
        }
        this.mblData.mbl = data.mawbNo
        if (this.jobUuid) {
          changeMAWBNo({ 'jobKey': this.jobUuid, 'mawbDetailUuid': data.uuid, 'mawbNo': data.mawbNo })
        }
      }
    },
    async weightActualChange() {
      this.mblData.cWeight = JobUtils.calcProportion(this.mblData.pbProportion, this.mblData.weightActual,
        this.mblData.cubageActual, true, this.cWeightIsCeil, this.splitBubbleCollectionFormat)
      this.mblData.cWeight = JobUtils.calcChargeWeight2(this.mblData.cWeight, true, this.cWeightIsCeil)
    },
    async weightStationChange() {
      this.mblData.chargeWeightStation = JobUtils.calcChargeWeight(this.mblData.weightStation, this.mblData.cubageStation, true, this.cWeightIsCeil)
      const weight = isNaN(this.mblData.weightStation) ? 0 : this.mblData.weightStation
      const cubAge = isNaN(this.mblData.cubageStation) ? 0 : this.mblData.cubageStation
      if (cubAge) {
        this.mblData.densityStation = NumberUtils.ToFixed2(weight / cubAge, 3)
      } else {
        this.mblData.densityStation = 0
      }
    },
    weightCubAgeChangeHandler() {
      this.mblData.chargeWeightBooking = JobUtils.calcChargeWeight(this.mblData.weightBooking, this.mblData.cubageBooking, true, this.cWeightIsCeil)
      const weight = isNaN(this.mblData.weightBooking) ? 0 : this.mblData.weightBooking
      const cubAge = isNaN(this.mblData.cubageBooking) ? 0 : this.mblData.cubageBooking
      if (cubAge) {
        this.mblData.densityBooking = NumberUtils.ToFixed2(weight / cubAge, 3)
      } else {
        this.mblData.densityBooking = 0
      }
    },
    jumpBusinessHandler(jobNo) {
      this.onCancel()
      doJumpFinaceOrBusiness(this, jobNo, 'AE', this.$store.getters.currentOfficeId, true)
    },
    setCargoSize() {
      this.measurements = ''
      if (this.lclData) {
        let masterMeasurements = ''
        for (const childJob of this.lclData) {
          if (childJob.bookingDimensions) {
            masterMeasurements += childJob.bookingDimensions + '\n'
          }
        }
        this.measurements = masterMeasurements
      }
    },
    onCancel(refresh = false) {
      this.$emit('close')
      if (refresh) {
        this.$emit('refresh')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 添加一些基本的样式 */
.container {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
}
.order-info {
  width: 15%;
  margin-bottom: 10px;
  border-right: 2px solid #67688d; /* 添加左边的竖直边框 */
}
.order-details {
  display: flex;
  justify-content: space-between;
}
.order-details div {
  border: 1px solid #ccc;
  padding: 10px;
  margin-right: 10px;
}
.order-details div:last-child {
  margin-right: 0;
}
.button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}
.scrollable-div {
  height: 750px;
  overflow: auto; /* 自动显示滚动条 */
  border: 1px solid #ccc;
  padding: 5px;
  margin: 5px auto;
  background-color: #f9f9f9;
  border-radius: 8px;
}

/* 定制滚动条样式 */
.scrollable-div::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条轨道透明 */
}

.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888; /* 滚动条滑块颜色 */
  border-radius: 3px; /* 滚动条滑块圆角 */
}

.scrollable-div::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 滚动条滑块悬停时的颜色 */
}
</style>
